export const TommySizeColumns = [
    "Size",
    "DIM",
    "SizeDescription",
    "BuySheetSize",
    "MovexSize",
    "BuyerName"
  ]


  